import { render } from "./AccountCancelResult.vue?vue&type=template&id=2e28bf57&scoped=true"
import script from "./AccountCancelResult.vue?vue&type=script&lang=js"
export * from "./AccountCancelResult.vue?vue&type=script&lang=js"

import "./AccountCancelResult.vue?vue&type=style&index=0&id=2e28bf57&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e28bf57"]])

export default __exports__